import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TooltipView from 'Components/tooltipView';
import * as styles from './tooltip.css';

export class Tooltip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState((prevState) => ({ expanded: !prevState.expanded }));
  }

  render() {
    const { content, className } = this.props.btnProps;
    return (
      <span
        className={styles.anchor}
        ref={(ref) => { this.anchor = ref; }}
      >
        <button
          className={className}
          onClick={this.onClick}
        >{content}</button>
        {this.state.expanded && (
          <TooltipView
            {...this.props}
            onClose={this.onClick}
          />
        )}
      </span>
    );
  }
}

Tooltip.propTypes = {
  btnProps: PropTypes.shape({
    content: PropTypes.node.isRequired,
    className: PropTypes.string.isRequired,
  }).isRequired,
  content: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  ]).isRequired,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./app/components/tooltip/index.js